module.exports = __webpack_public_path__ + "static/media/minus_blue.588a3d16.svg";